// extracted by mini-css-extract-plugin
export default {"emptyBlock_wrapper":"TransitionsTable_emptyBlock_wrapper__T1-OF","iconWrapper":"TransitionsTable_iconWrapper__p2pAK"};